<template>
  <div>
    <div>
      <b-row>
        <b-col>
          <b-card>
            <validation-observer ref="contractValidations">
              <b-tabs>
                <b-tab active :title="$t('agreement')">
                  <div class="top">
                    <div
                      class="d-flex align-items-center justify-content-between flex-wrap"
                    >
                      <div class="d-flex">
                        <b-form-group :label="$t('agreement')">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('agreement')"
                            rules=""
                          >
                            <b-form-input
                              :disabled="is_cash"
                              v-model="contract.contract_number"
                              :placeholder="$t('agreement')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group :label="$t('date')" class="ml-1">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('date')"
                            rules="required"
                          >
                            <VueDataPicker
                              class="date-dark"
                              v-model="contract.date"
                              placeholder="YYYY-MM-DD"
                              :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        
                        <b-form-group :label="$t('provider')" class="ml-1">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('provider')"
                            rules="required"
                          >
                            <div class="d-flex align-items-center">
                              <b-form-input
                                v-model="seller"
                                class="input__radius"
                                disabled
                              />
                              <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                v-b-modal.suppliers-modal
                                class="choose-btn"
                                style="min-width: 225px"
                                variant="primary"
                              >
                                <feather-icon
                                  class="mr-50"
                                  icon="AlignJustifyIcon"
                                  size="16"
                                />
                                {{ $t("select_from_registry") }}
                              </b-button>
                            </div>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                        <div class="d-flex align-items-center ml-1 mr-1">
                          <b-form-checkbox
                            v-model="is_cash"
                            name="check-button"
                            @input="isCashChanged($event)"
                            switch
                            inline
                          >
                            {{$t('cash')}}
                          </b-form-checkbox>
                        </div>
                      </div>


                      <b-form-group :label="$t('buyer')" class="">
                        <validation-provider
                          #default="{ errors }"
                          :name="$t('buyer')"
                          rules="required"
                        >
                          <div class="d-flex align-items-center">
                            <b-form-input
                              v-model="buyer"
                              class="input__radius"
                              disabled
                            />
                            <b-button
                              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                              v-b-modal.buyers-modal
                              class="choose-btn"
                              style="min-width: 225px"
                              variant="primary"
                            >
                              <feather-icon
                                class="mr-50"
                                icon="AlignJustifyIcon"
                                size="16"
                              />
                              {{ $t("select_from_registry") }}
                            </b-button>
                          </div>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>



                      <div class="d-flex">
                        <b-button
                          v-if="checkButtonPermission(['supplier', 'chief_supplier', 'accountant', 'chief_manager', 'admin'])"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          size="sm"
                          class="d-flex align-items-center"
                          variant="success"
                          @click="showModalAddFiles()"
                          :disabled="!isMounted"
                        >
                          <!-- @click="deleteApp(data)" -->
                          <feather-icon
                            icon="EyeIcon"
                            size="18"
                            class="mr-50"
                          />
                          {{$t('watch_files')}}
                        </b-button>
                      </div>
                    </div>
                  </div>

                  <hr class="mt-3 mb-2" />
                  <b-row>
                    <b-col class="col-md-12 text-center mb-1">
                      <h2>{{ $t("based_on_applications") }}</h2>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-end">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="outline-primary"
                        @click="openModalBasedOnApplication()"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        {{ $t("add") }}
                      </b-button>
                    </b-col>
                    <b-col cols="12">
                      <BasedOnAplication />
                    </b-col>
                  </b-row>

                  <b-row class="treaty mt-2">
                    <b-col md="12" class="mb-2 text-center">
                      <h2>{{ $t("subject_of_the_contract") }}</h2>
                    </b-col>

                    <b-col class="col-md-12 mb-3">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h4 class="mb-0">
                          {{ $t("reference.material") }}
                        </h4>

                      </div>
                      <MaterialsTable />
                    </b-col>
                    <b-col class="col-md-12 mb-2">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h4 class="mb-0">
                          {{ $t("reference.instrument") }}
                        </h4>

                      </div>
                      <InstrumentsTable />
                    </b-col>
                  </b-row>

                  <b-row class="sum mt-2">
                    <b-col class="col-md-12 text-center mb-1">
                      <h2>{{ $t("аmount_of_contract_and_invoice") }}</h2>
                    </b-col>
                    <b-col md="2">
                      <span
                        >{{ $t("total_amount") }}:&nbsp;{{
                          contract.total_sum
                        }}</span
                      >
                    </b-col>
                  </b-row>

                  <hr class="mt-1" />

                  <div class="text-right mt-3">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      class=""
                      variant="secondary"
                      @click="$router.push('/agreements')"
                    >
                      {{ $t("general.cancel") }}
                    </b-button>

                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      class="ml-2"
                      variant="primary"
                      @click="onSaveContract"
                    >
                      {{ $t("save") }}
                    </b-button>
                  </div>
                </b-tab>
              </b-tabs>
            </validation-observer>

            <BasedOnApplicationsModal></BasedOnApplicationsModal>
            <SuppliersModal @input="companyInput" />
            <BuyersModal @input="buyerCompanyInput" />
            <modalUniversal :type="type" />
          </b-card>
        </b-col>
      </b-row>
    </div>
    <addFilesModal1 :type="addFilestype"/>
    
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BCard,
  BTabs,
  BTab,
  BBadge,
  BFormCheckbox
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Ripple from "vue-ripple-directive";

import MaterialsTable from "./components/tables/materialsTable.vue";
import InstrumentsTable from "./components/tables/instrumentsTable.vue";

import BasedOnAplication from "./components/tables/BasedOnAplication.vue";

import SuppliersModal from "./components/modals/suppliersModal.vue";
import BuyersModal from "./components/modals/buyersModal.vue";
import modalUniversal from "./components/modals/modalMaterialInstrument.vue";
import BasedOnApplicationsModal from "./components/modals/BasedOnApplicationsModal.vue";

import VueDataPicker from "@/components/VueDatePicker.vue";
import objective from "@/mixins/objective";
import check from "@/mixins/check";
import loader from "@/mixins/loader";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import addFilesModal1 from './components/modals/addFilesModal1.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCard,
    BTabs,
    BTab,
    BBadge,
    BFormCheckbox,

    MaterialsTable,
    InstrumentsTable,
    SuppliersModal,
    BuyersModal,

    VueDataPicker,

    modalUniversal,
    BasedOnAplication,
    BasedOnApplicationsModal,

    ValidationObserver,
    ValidationProvider,

    addFilesModal1,
  },
  directives: {
    Ripple,
  },
  mixins: [objective, check, loader, priceFormatMixin],
  data() {
    return {




      // =============== PRIMARY_DATA START ===============
      type: true,
      seller: null,
      buyer: null,
      addFilestype: 'add',
      isMounted: false,
      _timerId: 0,
      is_cash: false,
      // =============== PRIMARY_DATA END ===============





    };
  },
  computed: {
    ...mapState("agrements", ["materialAndInstrumentApplications"]),














    // ========================= SETTERS_AND_GETTERS START =========================
    contract: {
      get: function () {
        return this.$store.state.agrements.contract;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_CONTRACT", newValue);
      },
    },
    materialItems: {
      get: function () {
        return this.$store.state.agrements.materialItems;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_MATERIAL_ITEMS", newValue);
      },
    },
    instrumentItems: {
      get: function () {
        return this.$store.state.agrements.instrumentItems;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_INSTRUMENT_ITEMS", newValue);
      },
    },
    viewMode: {
      get: function () {
        return this.$store.state.agrements.viewMode;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_VIEW_MODE", newValue);
      },
    },
    materialAndInstrumentApplications: {
      get: function () {
        return this.$store.state.agrements.materialAndInstrumentApplications;
      },
      set: function (newValue) {
        this.$store.commit(
          "agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS",
          newValue
        );
      },
    },
    contractFiles: {
      get: function () {
        return this.$store.state.agrements.contractFiles;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_CONTRACT_FILES', newValue)
      }
    },

    // ========================= SETTERS_AND_GETTERS END =========================
















    
  },
  watch: {
    // ========================= CALCULATE_SUM_WATCHERS START =========================
    materialItems: {
      deep: true,
      handler(newValue) {
        console.log('material')
        this.calculateSum();
      },
    },
    instrumentItems: {
      deep: true,
      handler(newValue) {
        console.log('instrument')
        this.calculateSum();
      },
    },
    materialAndInstrumentApplications: {
      deep: true,
      handler(newValue) {
        if (true) {
          this.materialItems = []
          this.instrumentItems = []


          let materials = [];
          let instruments = [];
          let goodsCheckExist = [];
          let goodsCheckNotExist = [];
          let instrumentsCheckExist = [];
          let instrumentsCheckNotExist = [];





          // // ==================== Used for splicing duplicated ====================
          // newValue.forEach((elem) => {
          //   if (elem.goods) {
          //     let withID = [];
          //     let withoutID = [];

          //     let goodsNew = elem.goods.map((item) => ({
          //       requirement_id: elem.id,
          //       id: null,
          //       product: item.good.product.title,
          //       good: item.good,
          //       count: item.count,
          //       price: item.price,
          //     }));

          //     withID = this.materialItems.filter((item2) =>
          //       item2.hasOwnProperty("id") && item2.id != null
          //     );
          //     withoutID = this.materialItems.filter(
          //       (item2) => !item2.hasOwnProperty("id") || (item2.hasOwnProperty("id") && item2.id == null)
          //     );

           

          //     goodsNew.forEach((item1) => {
          //       if (withID.length != 0) {
          //         goodsCheckNotExist = withID.find((item2) => {
          //           if (item1.id != item2.id) {
          //             return item2;
          //           }
          //         });

          //         if (goodsCheckNotExist) {
          //           let indexOfSplicingItem = this.materialItems.findIndex((item10) => item10.id == goodsCheckNotExist.id);
          //           this.materialItems.splice(indexOfSplicingItem, 1);
          //         }
          //       }
          //     });
          //   } else if (elem.instruments) {
          //     let withID = [];
          //     let withoutID = [];

          //     let instrumentsNew = elem.instruments.map((item) => ({
          //       requirement_id: elem.id,
          //       id: null,
          //       product: item.instrument.type.title,
          //       instrument: item.instrument,
          //       count: item.count,
          //       price: item.price,
          //     }));

          //     withID = this.instrumentItems.filter((item2) =>
          //       item2.hasOwnProperty("id") && item2.id != null
          //     );
          //     withoutID = this.instrumentItems.filter(
          //       (item2) => !item2.hasOwnProperty("id") || (item2.hasOwnProperty("id") && item2.id == null)
          //     );

          //     instrumentsNew.forEach((item1) => {
          //       if (withID.length != 0) {
          //         instrumentsCheckNotExist = withID.find((item2) => {
          //           if (item1.id != item2.id) {
          //             return item2;
          //           }
          //         });

          //         if (instrumentsCheckNotExist) {
          //           let indexOfSplicingItem = this.instrumentItems.findIndex((item10) => item10.id == instrumentsCheckNotExist.id);
          //           this.instrumentItems.splice(indexOfSplicingItem, 1);
          //         }
          //       }
          //     });
          //   }
          // });
          // // ==================== Used for splicing duplicated ====================

        




          newValue.forEach((elem) => {
            console.log(elem)
            if (elem.goods) {

              let goodsNew = elem.goods.map((item) => ({
                requirement_id: elem.id,
                id: null,
                product: item?.good?.product?.title,
                good: item.good,
                count: item.count,
                responsible: item.responsible,
                quantity_sum: item.quantity_sum,
                price: item.price,
              }));

         

              goodsNew.forEach((item1) => {
                if(this.materialItems.length > 0){
                  this.materialItems.forEach((item2) => {
                    if(item2.good.id != item1.good.id){
                      materials.push(item1);
                    }
                  })
                }else{
                  materials.push(item1);
                }
              });

            }else if (elem.instruments) {

              let instrumentsNew = elem.instruments.map((item) => ({
                requirement_id: elem.id,
                id: null,
                product: item?.instrument?.type?.title,
                instrument: item.instrument,
                count: item.count,
                responsible: item.responsible,
                quantity_sum: item.quantity_sum,
                price: item.price,
              }));

             

              instrumentsNew.forEach((item1) => {
                if(this.instrumentItems.length > 0){
                  this.instrumentItems.forEach((item2) => {
                    if(item2.instrument.id != item1.instrument.id){
                      instruments.push(item1);
                    }
                  })
                }else{
                  instruments.push(item1);
                }
              });

            }
          });


          
          this.materialItems = this.materialItems.concat(materials);
          this.instrumentItems = this.instrumentItems.concat(instruments);

          this.materialItems = this.materialItems.filter((elem) => elem.count != 0);
          this.instrumentItems = this.instrumentItems.filter((elem) => elem.count != 0);
        }
      },
    },
    // ========================= CALCULATE_SUM_WATCHERS END =========================






  },
  async created(){





    // ========================= PRIMARY_INITIALIZATION START =========================
    this.contract.type_contract = true
    this.contract.contract_number = null
    this.contract.seller = null
    this.contract.buyer = null
    this.contract.goods = []
    this.contract.instrument = []
    this.contract.date = null
    this.contract.total_sum = 0
    
    this.seller = null
    this.buyer = null
    this.addFilestype = 'add',
    this.type = true

    this.materialAndInstrumentApplications = []
    this.materialItems = []
    this.instrumentItems = []
    this.contractFiles = []

    this.viewMode = false
    // ========================= PRIMARY_INITIALIZATION END =========================





  },
  async mounted() {
    await this.$_loaderStart();



   

    // ========================= VIEW_AND_EDIT_MODES START =========================
    this.isMounted = true
    // ========================= VIEW_AND_EDIT_MODES END =========================




  },
  async beforeRouteLeave(to, from, next) {
    await this.$_loaderStop();
    next();
  },
  methods: {
    ...mapActions("agrements", [
      "CREATE_CONTRACTS_LIST",
      "FETCH_ONE_CONTRACTS",
    ]),













    // ===============  SEARCH_SECTION START ===============
    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "total_sum") {
          this.contract.total_sum = currency;
        } else if (type == "currency") {
          return currency;
        }
      }
      return 0;
    },
    // ===============  SEARCH_SECTION END ===============


















    // ========================= CALCULATE_SUM START =========================
    calculateSum() {
      this.$set(this.contract, "total_sum", 0);

      this.materialItems.forEach((item) => {
        item.count = this.formatPrice(item.count, "currency");
        item.price = this.formatPrice(item.price, "currency");
        if (item.count && item.price) {
          this.contract.total_sum +=
            item.count.toString().replace(/,/g, "") *
            item.price.toString().replace(/,/g, "");
        }
      });
      this.instrumentItems.forEach((item) => {
        item.count = this.formatPrice(item.count, "currency");
        item.price = this.formatPrice(item.price, "currency");
        if (item.count && item.price) {
          this.contract.total_sum +=
            item.count.toString().replace(/,/g, "") *
            item.price.toString().replace(/,/g, "");
        }
      });

      this.formatPrice(this.contract.total_sum, "total_sum");
    },
    // ========================= CALCULATE_SUM END =========================

















  

    // ========================= ON_SAVE_CONTRACT START =========================
    async onSaveContract() {
      const isValid = await this.$refs.contractValidations.validate();

      if (isValid) {
        const data = {
          date: this.contract.date,
          seller: this.contract.seller,
          buyer: this.contract.buyer,
          goods: [],
          instruments: [],
          requirement_goods: [],
          requirement_instruments: [],
          contract_number: this.contract.contract_number,
          amount: this.contract.total_sum.toString().replace(/,/g, ""),
          type_contract: true,
          is_cash: this.is_cash
        };

        if(this.is_cash){
          this.contract.contract_number = null
        } 

        this.materialAndInstrumentApplications.forEach((elem) => {
          if (elem && elem.goods) {
            data.requirement_goods.push(elem.id);
          }
          if (elem && elem.instruments) {
            data.requirement_instruments.push(elem.id);
          }
        });
        
        this.materialItems.forEach((elem) => {
          data.goods.push({
            id: elem.id,
            requirement_id: elem.requirement_id,
            good_id: elem.good.id,
            count: parseFloat(elem.count.toString().replace(/,/g, "")),
            price: parseFloat(elem.price.toString().replace(/,/g, "")),
          });
        });

        this.instrumentItems.forEach((elem) => {
          data.instruments.push({
            id: elem.id,
            requirement_id: elem.requirement_id,
            instrument_id: elem.instrument.id,
            count: parseFloat(elem.count.toString().replace(/,/g, "")),
            price: parseFloat(elem.price.toString().replace(/,/g, "")),
          });
        });


        let formData = new FormData()
        this.contractFiles.forEach((elem) => {formData.append('files', elem.url)})

        formData.append("created_at", data.date);
        formData.append("is_cash", data.is_cash);
        formData.append("seller", data.seller);
        formData.append("buyer", data.buyer);
        formData.append("goods", JSON.stringify(data.goods));
        formData.append("instruments", JSON.stringify(data.instruments));
        formData.append("requirement_goods",  JSON.stringify(data.requirement_goods));
        formData.append("requirement_instruments",  JSON.stringify(data.requirement_instruments));
        formData.append("contract_number", data.contract_number);
        formData.append("amount", data.amount);
        formData.append("type_contract", data.type_contract);

        if (this.materialItems.length == 0 && this.instrumentItems.length == 0) {
          this.$_errToast({ message: this.$t('supply_of_materials_and_tools') });
        } else {
         
          this.CREATE_CONTRACTS_LIST(formData)
            .then(() => {
              this.$router.push("/agreements");
              this.$_okToast();
            })
            .catch((err) => {
              if (
                err &&
                err.response &&
                err.response.data &&
                err.response.data.error_count_more_the_count
              ) {
                this.$_errToast({
                  message: err.response.data.error_count_more_the_count[0],
                });
              }

              if (
                err &&
                err.response &&
                err.response.data &&
                err.response.data.contract_number
              ) {
                this.$_errToast({
                  message: err.response.data.contract_number[0],
                });
              }
            });
        }
      } else {
        this.$_errToast({ message: this.$t("general.no_valid") });
      }
    },
    // ========================= ON_SAVE_CONTRACT END =========================




















    // ========================= SHOW_MODALS END =========================
    openModal(type) {
      this.type = type;
      this.$bvModal.show("modalUniversal");
    },
    openModalBasedOnApplication() {
      this.$bvModal.show("BasedOnAplication");
    },
    showModalAddFiles(id){
      this.addFilestype = 'show'
      this.$bvModal.show('addFilesModal1')
    },
    // ========================= SHOW_MODALS END =========================














    // ========================= OTHERS START =========================
    isCashChanged(event){
      if(event){
        this.contract.contract_number = this.$i18n.locale == 'ru' ? "Наличные" : "Naqd"
      }
    },
    companyInput(e) {
      this.seller = e.company_name;
      this.$set(this.contract, "seller", e.id);
    },
    buyerCompanyInput(e) {
      this.buyer = e.company_name;
      this.$set(this.contract, "buyer", e.id);
    },
    // ========================= OTHERS END =========================




    
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.dark-layout .date-dark input {
  background-color: #283046 !important;
}

.repeater-form {
  transition: 0.35s height;
}

.choose-btn {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  display: flex;
  align-items: center;
}

.input__radius {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  min-width: 300px;
}
</style>
